import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Flex } from '@ui-library/misc';
import AuditLogsData from './auditLogsData';
import useInfiniteScroll from '@hooks/useInfiniteScroll';
import useStores from '@stores/useStores';
import { observer } from 'mobx-react';
import classes from './auditLogs.module.scss';
import { H4 } from '@ui-library/typography';
import { DropdownContainer } from '../styles';

export enum LogType {
  ALL = 'all',
  SOURCE = 'source',
  DESTINATION = 'destination',
  TEAM = 'team',
  TRANSFORMATION = 'transformation',
  MFA = 'MFA',
}

const tabs = [
  {
    label: 'All',
    value: LogType.ALL,
  },
  {
    label: 'Source',
    value: LogType.SOURCE,
  },
  {
    label: 'Destination',
    value: LogType.DESTINATION,
  },
  {
    label: 'Team',
    value: LogType.TEAM,
  },
  {
    label: 'Transformation',
    value: LogType.TRANSFORMATION,
  },
  {
    label: 'MFA',
    value: LogType.MFA,
  },
];
const AuditLogs = () => {
  const [target, setTarget] = useState(tabs[0].value);
  const { auditLogsStore } = useStores();
  useEffect(() => {
    getData();
  }, [target]);

  function getData() {
    auditLogsStore.getLogs(LogType[target.toUpperCase() as keyof typeof LogType]);
  }

  const loadMore = useMemo(
    () => () => {
      auditLogsStore.getMore();
    },
    [],
  );

  const endPageRef = useRef(null);
  useInfiniteScroll(endPageRef, loadMore);

  return (
    <>
      <Flex className={classes.headerContainer}>
        <Flex alignItems="center" className={classes.header}>
          <H4 className="m-b-xs">Audit Logs</H4>
        </Flex>
        <Flex justifyContent="flex-end" className={classes.filterContainer}>
          <Flex alignItems="center">
            <div>View: </div>
            <DropdownContainer
              className={classes.dropdownContainer}
              onChange={(value) => setTarget(value)}
              value={target}
              options={tabs}
            />
          </Flex>
        </Flex>
      </Flex>
      <Flex flexDirection="column" className={classes.auditTableContainer}>
        <AuditLogsData logs={auditLogsStore.parsedLogs} loading={auditLogsStore.loading} />
        <div ref={endPageRef} />
      </Flex>
    </>
  );
};

export default observer(AuditLogs);
